import script from "./DismissibleBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./DismissibleBanner.vue?vue&type=script&setup=true&lang=js"

import "./DismissibleBanner.vue?vue&type=style&index=0&id=4c45b2d8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c45b2d8"]])

export default __exports__